import { css, type DefaultTheme } from 'styled-components'
import type { CSS } from 'types/style'
import colors from 'utils/styling/colors'

export const windowsScrollbar = ({
  theme,
}: {
  theme: DefaultTheme
}): CSS | null | false => {
  if (!theme || !theme.os) {
    return null
  }
  const { os } = theme
  return (
    os.includes('Windows') &&
    css`
      &::-webkit-scrollbar {
        background: ${colors('gray5')};
        transition: 0.25s;
      }
      &::-webkit-scrollbar-thumb {
        background: ${colors('gray4')};
        &:hover {
          background: ${colors('gray4', 90)};
        }
        transition: 0.25s;
      }
    `
  )
}

export default windowsScrollbar
